import React, { useEffect, useRef, useState } from 'react'
import Base64Downloader from 'common-base64-downloader-react';
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button';
import apis from '../../api';
// import emailjs from '@emailjs/browser';

const TermsModal = (props) => {


    const [textLegalTerms, setTextLegalTerms] = useState([]);
    const [fileTerms, setFileTerms] = useState("");
    const [filePolicies, setFilePolicies] = useState("");
    const [nameTerms, setNameTerms] = useState("");
    const [namePolicies, setNamePolicies] = useState("");
    const { accept, cancel, isOpenTerms, setIsOpenTerms, loading, setLoading } = props

    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);

    useEffect(() => {
        const template = async () => {
            /*Se encarga de mostar el spinner de la vista si no se ha clickeado el botón*/
            await apis.postLegalTerms({}).then(res => {
                let doc1 = "data:application/pdf;base64," + res.data.PDF_POLICIES.DATA
                let doc2 = "data:application/pdf;base64," + res.data.PDF_TERMS.DATA
                setFileTerms(doc2)
                setFilePolicies(doc1)
                setNameTerms(res.data.PDF_TERMS.NAME)
                setNamePolicies(res.data.PDF_POLICIES.NAME)
                var textLegal = res.data.TXT.split("|");
                setTextLegalTerms(textLegal);
                console.log(textLegal)
            }).catch(err => {
                console.log(err)
            })
        }
        template()
    }, []);

    const termsFooter = () => {
        return (
            <div className='flex flex-row justify-content-between mt-2 gap-2 flex-wrap'>
                <div className='flex flex-row mb-2'>
                    <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={filePolicies} downloadName={namePolicies} onDownloadSuccess={() => { setLoading2(false) }}>
                        <Button label="Política de datos" icon="pi pi-file-pdf" onClick={() => setLoading2(true)} className="p-button-outlined p-button-sm" />
                    </Base64Downloader>
                </div>
                <div className='flex flex-row gap-2 flex-wrap'>
                    <Button label="No Acepto" icon="pi pi-times" onClick={() => cancel()} className="p-button" />
                    <Button label="Acepto" loading={loading} icon="pi pi-check" onClick={() => { setLoading(true); accept() }} className="p-button" />
                </div>
            </div>
        );
    }

    return (
        <div>
            <Dialog header="Políticas de privacidad" visible={isOpenTerms} style={{ width: '90vw' }} footer={termsFooter} onHide={() => { cancel() }}>
                {
                    textLegalTerms.map((item, index) => {
                        return <div key={index}> <p >{item}</p> <br /></div>
                    })
                }
            </Dialog>
        </div>
    )
}

export default TermsModal;